import { useAtomValue } from 'jotai';

import { Sidebar } from './Sidebar';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { sidebarCollapseAtom } from '@/store/atoms';
import { cn } from '@/utils/utils';

export const AppHeader = () => {
  const isCollapsed = useAtomValue(sidebarCollapseAtom);
  const headerContent = (
    <div
      className={cn(
        'border-sidebar-border relative flex items-center border-b p-2',
        'transition-all duration-300',
        isCollapsed ? 'justify-center' : 'justify-start',
      )}
    >
      <div
        className={cn(
          'flex items-center',
          isCollapsed ? 'justify-center' : 'justify-start',
        )}
      >
        <img
          src={isCollapsed ? '/Icon-Transparent.svg' : '/Full-Transparent.svg'}
          alt="October AI Logo"
          className={cn(
            'object-contain',
            isCollapsed ? 'h-8 w-8' : 'h-14 w-auto max-w-full',
          )}
        />
      </div>
      <div className={cn('absolute', isCollapsed ? '-right-2' : 'right-1')}>
        <Sidebar.Toggle />
      </div>
    </div>
  );

  if (isCollapsed) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>{headerContent}</TooltipTrigger>
        <TooltipContent side="right" className="ml-2">
          <span>October AI</span>
        </TooltipContent>
      </Tooltip>
    );
  }

  return headerContent;
};
